import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";

export async function trackUserPageActivity(email, persona, tabLabel) {
    try {
        const responseDataText = await authenticatedFetch(URL.trackActivityApi, {
            method: "POST",
            body: JSON.stringify({
                email: email,
                role: persona,
                page_name: tabLabel,
            }),
        });
        return responseDataText;
    } catch (error) {
        console.error("Error tracking page activity:", error.message);
        throw error;
    }
}
